import { createUseStyles } from 'react-jss';

interface Props {
  section: any;
  role: any;
};

const useStyles = createUseStyles((theme: any) => ({
  section: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    borderRadius: '24px',
    overflow: 'hidden',
    backgroundImage: (props: Props) => `url("/resources/images/welcomescreen/${props.role}_${props.section}.png")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
  header: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 'calc(100% - 96px)',
    marginTop: '64px',
    marginLeft: '48px',
    '& > svg': {
      width: 'auto',
      height: '48px',
    },
    [theme.breakpoints.down('lg')]: {
      marginTop: '24px',
    },
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxHeight: '100%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      flex: 'unset',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100% - 100px)',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '48px',
    marginTop: 'auto',
    marginBottom: 'auto',
    marginLeft: '100px',
    overflow: 'auto',
    '&::after': {
      content: `''`,
      display: 'block',
      width: '100%',
      height: '24px',
    },
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '800px',
    maxWidth: '100%',
    '& > span': {
      fontSize: '36px',
      fontWeight: '600',
      color: theme.colors.primaryBlue[500],
    },
    '& > em': {
      fontStyle: 'normal',
      fontWeight: '700',
    },
    '& > p': {
      color: theme.colors.grey[500],
      width: '50%',
      fontSize: '16px',
    },
  },
  buttons: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
    width: '80%',
    '& > button': {
      '&:first-of-type': {
        borderColor: '#C9DAED',
        borderWidth: '1px',
      },
    },
  },
}));

export default useStyles;